module.exports = __webpack_public_path__ + "img/red_bottom.33513309.png";